export default {
  traitManager: {
    appendTo: '.traits-container',
  },
}
